/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const n=Symbol("GroundInstance");function o(o){return null!=o&&"object"==typeof o&&n in o}export{n as GroundSymbol,o as isGround};
